import { render, staticRenderFns } from "./mailSideBar.vue?vue&type=template&id=264329a7&"
import script from "./mailSideBar.vue?vue&type=script&lang=js&"
export * from "./mailSideBar.vue?vue&type=script&lang=js&"
import style0 from "./mailSideBar.vue?vue&type=style&index=0&id=264329a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports